import { RouteObject } from 'react-router-dom';
import { Roles } from '@/core/types';
import RolesGuard from '@/router/guards/RolesGuard';
import LogsPage from '@/views/pages/logs';

export default [
	{
		path: 'logs',
		element: (
			<RolesGuard roles={[Roles.LEVIANT_ADMIN, Roles.SITE_SUPERVISOR]} element={<LogsPage />} />
		),
	},
] as RouteObject[];
